import React, { useRef } from 'react';
import './Settings.scss';
import { getObjectFromForm, injectPhpDebug } from '../../../../../mol_function';
import { request } from 'express';
import MolLink from '../../Basepage/parts/Menu/MolLink';

interface SettingsProps {
  data: any;
  apibase: string;
}
interface SettingsState {
  kaufMode: string;
  v_Montag: boolean;
  v_Dienstag: boolean;
  v_Mittwoch: boolean;
  v_Donnerstag: boolean;
  v_Freitag: boolean;
  showVerandTage: boolean;
}

export default class Settings extends React.Component<
  SettingsProps,
  SettingsState
> {
  fotmRef: React.RefObject<HTMLFormElement>;

  createState(data: any) {
    let newState: any = {};
    let tage = data?.versandTage.split(',') ?? [];

    if (this.state.kaufMode != data?.kaufMode)
      newState.kaufMode = data?.kaufMode ?? '';
    if (tage.includes('0') != this.state.v_Montag)
      newState.v_Montag = tage.includes('0');
    if (tage.includes('1') != this.state.v_Dienstag)
      newState.v_Dienstag = tage.includes('1');
    if (tage.includes('2') != this.state.v_Mittwoch)
      newState.v_Mittwoch = tage.includes('2');
    if (tage.includes('3') != this.state.v_Donnerstag)
      newState.v_Donnerstag = tage.includes('3');
    if (tage.includes('4') != this.state.v_Freitag)
      newState.v_Freitag = tage.includes('4');

    newState.showVerandTage = data?.showVersandTage == true;

    this.setState(newState);
  }

  constructor(props) {
    super(props);
    this.state = {
      showVerandTage: false,
      kaufMode: '',
      v_Montag: false,
      v_Dienstag: false,
      v_Mittwoch: false,
      v_Donnerstag: false,
      v_Freitag: false,
    };
    this.fotmRef = React.createRef();
  }
  render(): React.ReactNode {
    return (
      <div id="konto_settings">
        <h3>Einstellungen</h3>
        <br />
        <br />
        <form key="form_setiings" ref={this.fotmRef}>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Standard Bezugsvariante</td>
                <td>
                  <input
                    type="radio"
                    name="mode"
                    checked={this.state.kaufMode == 'schnell'}
                    onChange={(e) => this.changedEventHandler(e)}
                    id="schnell_mode_radio"
                    key="bezug_schnell"
                  />{' '}
                  schnellstmöglich
                  <br />
                  <input
                    type="radio"
                    name="mode"
                    checked={this.state.kaufMode == 'standart'}
                    onChange={(e) => this.changedEventHandler(e)}
                    key="bezug_standart"
                  />{' '}
                  günstigst
                </td>
              </tr>
              {this.state.showVerandTage ? (
                <tr>
                  <td>Versandtage</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.v_Montag}
                      key="v_Montag"
                      id="v_Montag"
                      onChange={(e) => this.changedEventHandler(e)}
                    />{' '}
                    Montag
                    <br />
                    <input
                      type="checkbox"
                      checked={this.state.v_Dienstag}
                      key="v_Dienstag"
                      id="v_Dienstag"
                      onChange={(e) => this.changedEventHandler(e)}
                    />{' '}
                    Dienstag
                    <br />
                    <input
                      type="checkbox"
                      checked={this.state.v_Mittwoch}
                      key="v_Mittwoch"
                      id="v_Mittwoch"
                      onChange={(e) => this.changedEventHandler(e)}
                    />{' '}
                    Mittwoch
                    <br />
                    <input
                      type="checkbox"
                      checked={this.state.v_Donnerstag}
                      key="v_Donnerstag"
                      id="v_Donnerstag"
                      onChange={(e) => this.changedEventHandler(e)}
                    />{' '}
                    Donnerstag
                    <br />
                    <input
                      type="checkbox"
                      checked={this.state.v_Freitag}
                      key="v_Freitag"
                      id="v_Freitag"
                      onChange={(e) => this.changedEventHandler(e)}
                    />{' '}
                    Freitag
                    <br />
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </form>
        <br />
        <br />
        <div>
          Bitte legen Sie Ihren gewünschten Versandtag fest. Selbstverständlich
          können Sie auch mehrere Tage auswählen.
          <br />
          <br />
          Wir sammeln Ihre Bestellungen für Sie und versenden alle
          versandbereiten Artikel an dem von Ihnen gewählten Versandtag. So
          fallen <b>nur einmalig Portokosten</b> an. <br />
          Die Versandtage können bei Bedarf auch geändert werden. <br />
          <br />
          Sollten Sie Artikel eiliger benötigen, können Sie den Versand der
          versandbereiten Artikel unabhängig von Ihren Versandtagen anstoßen.
          Gehen Sie dazu zum Menüpunkt{' '}
          <MolLink to="/konto/readyToSend" href="/konto/readyToSend">
            Bereit zum Versand
          </MolLink>{' '}
          und klicken auf <b>„Versand veranlassen“</b>.<br />
          <br />
          <b>Bitte beachten Sie, dass wir an Feiertagen nicht ausliefern!</b>
          Sollten Sie zu <b>abweichenden Lieferanschriften</b> andere
          Versandtage wünschen, geben Sie diese bitte bei der Angabe der
          Lieferanschrift an. <br />
          <br />
          Alternativ haben Sie die Möglichkeit, die Versandtage in Ihrem{' '}
          <MolLink to="/konto/address" href="/konto/address">
            Adressbuch
          </MolLink>{' '}
          direkt an der Lieferanschrift zu hinterlegen oder zu ändern.
        </div>
      </div>
    );
  }
  componentDidMount(): void {
    this.createState(this.props.data);
  }
  changedEventHandler(e) {
    let doc: any = document;
    let data = {
      mode: doc.getElementById('schnell_mode_radio')?.checked
        ? 'schnell'
        : 'standart',
      // Tages-Checkboxen sind nicht in jedem Modus gerendert -> State behalten
      v_Montag: doc.getElementById('v_Montag')?.checked ?? this.state.v_Montag,
      v_Dienstag:
        doc.getElementById('v_Dienstag')?.checked ?? this.state.v_Dienstag,
      v_Mittwoch:
        doc.getElementById('v_Mittwoch')?.checked ?? this.state.v_Mittwoch,
      v_Donnerstag:
        doc.getElementById('v_Donnerstag')?.checked ?? this.state.v_Donnerstag,
      v_Freitag: doc.getElementById('v_Freitag')?.checked ?? this.state.v_Freitag,
    };

    let url = injectPhpDebug(
      this.props.apibase + '/Account.php?module=settings',
    );
    fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        settings: data,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        this.createState(data.body.settings);
      });
  }

  updateSettings() {}
}
